/* ============================================================
   FOODIES DELIVERY — THEME.JS  (Manus-matched rebuild)
   ============================================================ */

(function() {
  'use strict';

  /* ---- HAMBURGER MENU ---- */
  var hamburger = document.getElementById('hamburger');
  var mobileNav = document.getElementById('mobile-nav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function() {
      var isOpen = mobileNav.classList.toggle('open');
      hamburger.setAttribute('aria-expanded', isOpen);
    });
    document.addEventListener('click', function(e) {
      if (!hamburger.contains(e.target) && !mobileNav.contains(e.target)) {
        mobileNav.classList.remove('open');
        hamburger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---- HOURS BANNER ---- */
  function updateHoursBanner() {
    var banner = document.getElementById('hours-banner');
    var text = document.getElementById('hours-text');
    if (!banner || !text) return;
    var now = new Date();
    var totalMin = now.getHours() * 60 + now.getMinutes();
    var openMin = 11 * 60;
    var closeMin = 20 * 60;
    if (totalMin >= openMin && totalMin < closeMin) {
      banner.style.background = '#fff8f0';
      banner.style.color = '#7a4000';
      banner.style.borderBottom = '1px solid #ffe0c0';
      text.textContent = "We're currently open! We accept orders daily from 11:00 AM - 8:00 PM";
    } else {
      banner.style.background = '#fff5f5';
      banner.style.color = '#8b0000';
      banner.style.borderBottom = '1px solid #ffd0d0';
      text.textContent = "We're currently closed. We accept orders daily from 11:00 AM - 8:00 PM";
    }
  }
  updateHoursBanner();

  /* ---- FORMAT MONEY ---- */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---- CART DRAWER ---- */
  var cartToggle = document.getElementById('cart-toggle');
  var cartClose = document.getElementById('cart-close');
  var cartOverlay = document.getElementById('cart-overlay');
  var cartDrawer = document.getElementById('cart-drawer');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    loadCart();
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  function loadCart() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { renderCartDrawer(cart); })
      .catch(function() {});
  }

  function renderCartDrawer(cart) {
    var itemsEl = document.getElementById('cart-drawer-items');
    var footerEl = document.getElementById('cart-drawer-footer');
    var countEl = document.getElementById('cart-count');
    var subtotalEl = document.getElementById('cart-subtotal');
    if (!itemsEl) return;

    if (countEl) {
      countEl.textContent = cart.item_count;
      countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
    }

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="cart-empty-state"><div class="cart-empty-icon">🛍️</div><p>Your cart is empty</p><a href="/collections/all" class="btn-shop-now">Browse Menu</a></div>';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }

    var html = '';
    cart.items.forEach(function(item) {
      var img = item.image
        ? '<img src="' + item.image + '" alt="' + item.title + '" class="drawer-item__img">'
        : '<div class="drawer-item__img-placeholder">🍔</div>';
      var props = '';
      if (item.properties) {
        Object.keys(item.properties).forEach(function(k) {
          if (item.properties[k]) props += '<span style="display:block;font-size:0.75rem;color:#888;">' + k + ': ' + item.properties[k] + '</span>';
        });
      }
      html += '<div class="drawer-item" data-key="' + item.key + '">' +
        img +
        '<div class="drawer-item__info">' +
          '<div class="drawer-item__title">' + item.product_title + '</div>' +
          (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="drawer-item__variant">' + item.variant_title + '</div>' : '') +
          props +
          '<div class="drawer-item__price">' + formatMoney(item.final_line_price) + '</div>' +
          '<div class="drawer-item__qty">' +
            '<button class="drawer-qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '">-</button>' +
            '<span class="drawer-qty-num">' + item.quantity + '</span>' +
            '<button class="drawer-qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
          '</div>' +
        '</div>' +
        '<button class="drawer-item__remove" data-key="' + item.key + '" aria-label="Remove"><i class="fas fa-times"></i></button>' +
        '</div>';
    });
    itemsEl.innerHTML = html;

    if (footerEl) {
      footerEl.style.display = 'block';
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    }

    itemsEl.querySelectorAll('.drawer-qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        updateCartItem(btn.dataset.key, parseInt(btn.dataset.qty));
      });
    });
    itemsEl.querySelectorAll('.drawer-item__remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        updateCartItem(btn.dataset.key, 0);
      });
    });
  }

  function updateCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function(r) { return r.json(); })
      .then(function(cart) { renderCartDrawer(cart); })
      .catch(function() {});
  }

  /* ---- INITIAL CART COUNT ---- */
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var countEl = document.getElementById('cart-count');
      if (countEl) {
        countEl.textContent = cart.item_count;
        countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
    })
    .catch(function() {});

  /* ---- ADD TO CART (product page) ---- */
  var atcForm = document.getElementById('product-form');
  var atcBtn = document.getElementById('atc-btn');
  if (atcForm && atcBtn) {
    atcForm.addEventListener('submit', function(e) {
      e.preventDefault();
      atcBtn.disabled = true;
      atcBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Adding...';
      var data = new FormData(atcForm);
      fetch('/cart/add.js', { method: 'POST', body: data })
        .then(function(r) { return r.json(); })
        .then(function() {
          atcBtn.innerHTML = '<i class="fas fa-check"></i> Added!';
          atcBtn.style.background = '#16a34a';
          atcBtn.style.borderColor = '#16a34a';
          setTimeout(function() {
            atcBtn.disabled = false;
            atcBtn.innerHTML = '<i class="fas fa-shopping-bag"></i> Add to Order';
            atcBtn.style.background = '';
            atcBtn.style.borderColor = '';
          }, 2000);
          openCart();
        })
        .catch(function() {
          atcBtn.disabled = false;
          atcBtn.innerHTML = 'Try Again';
        });
    });
  }

  /* ---- QUANTITY SELECTOR ---- */
  var qtyInput = document.getElementById('qty-input');
  if (qtyInput) {
    var qtyDec = document.querySelector('.qty-dec');
    var qtyInc = document.querySelector('.qty-inc');
    if (qtyDec) qtyDec.addEventListener('click', function() {
      var v = parseInt(qtyInput.value) || 1;
      if (v > 1) qtyInput.value = v - 1;
    });
    if (qtyInc) qtyInc.addEventListener('click', function() {
      qtyInput.value = (parseInt(qtyInput.value) || 1) + 1;
    });
  }

  /* ---- VARIANT SELECTOR ---- */
  document.querySelectorAll('.option-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var group = btn.closest('.option-values');
      if (group) group.querySelectorAll('.option-btn').forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
      updateVariant();
    });
  });

  function updateVariant() {
    var selected = [];
    document.querySelectorAll('.option-values').forEach(function(group) {
      var active = group.querySelector('.option-btn.active');
      if (active) selected.push(active.dataset.value);
    });
    var variantInput = document.getElementById('variant-id');
    if (!variantInput || !window.__productVariants) return;
    var match = window.__productVariants.find(function(v) {
      return v.options.every(function(opt, i) { return opt === selected[i]; });
    });
    if (match) {
      variantInput.value = match.id;
      var priceEl = document.getElementById('product-price');
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (atcBtn) {
        atcBtn.disabled = !match.available;
        atcBtn.innerHTML = match.available ? '<i class="fas fa-shopping-bag"></i> Add to Order' : 'Sold Out';
      }
    }
  }

  /* ---- CUSTOMIZATION TAGS ---- */
  var customTags = document.querySelectorAll('.custom-tag');
  var customInput = document.getElementById('customizations-input');
  if (customTags.length && customInput) {
    customTags.forEach(function(tag) {
      tag.addEventListener('click', function() {
        tag.classList.toggle('active');
        var selected = [];
        customTags.forEach(function(t) {
          if (t.classList.contains('active')) selected.push(t.dataset.value);
        });
        customInput.value = selected.join(', ');
      });
    });
  }

  /* ---- SPECIAL INSTRUCTIONS CHAR COUNT ---- */
  var siInput = document.getElementById('special-instructions');
  var charCount = document.getElementById('char-count');
  if (siInput && charCount) {
    siInput.addEventListener('input', function() {
      charCount.textContent = siInput.value.length;
    });
  }

  /* ---- GALLERY THUMBNAILS ---- */
  var mainImg = document.getElementById('gallery-main-img');
  document.querySelectorAll('.gallery-thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      document.querySelectorAll('.gallery-thumb').forEach(function(t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (mainImg) { mainImg.src = thumb.dataset.src; mainImg.alt = thumb.dataset.alt || ''; }
    });
  });

  /* ---- CART PAGE AJAX QTY ---- */
  document.querySelectorAll('.cart-qty-dec, .cart-qty-inc').forEach(function(btn) {
    btn.addEventListener('click', function() {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: btn.dataset.key, quantity: parseInt(btn.dataset.qty) })
      }).then(function() { location.reload(); });
    });
  });

  /* ---- BACK TO TOP ---- */
  var btt = document.getElementById('back-to-top');
  if (btt) {
    window.addEventListener('scroll', function() { btt.classList.toggle('visible', window.scrollY > 400); });
    btt.addEventListener('click', function() { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ---- SCROLL REVEAL ---- */
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
    document.querySelectorAll('.reveal').forEach(function(el) { revealObserver.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function(el) { el.classList.add('visible'); });
  }

  /* ---- FAQ ACCORDION ---- */
  document.querySelectorAll('.faq-question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var answer = btn.nextElementSibling;
      var isOpen = btn.classList.contains('open');
      document.querySelectorAll('.faq-question').forEach(function(b) {
        b.classList.remove('open');
        if (b.nextElementSibling) b.nextElementSibling.classList.remove('open');
      });
      if (!isOpen) {
        btn.classList.add('open');
        if (answer) answer.classList.add('open');
      }
    });
  });

  /* ---- HEADER ORDER BUTTON (show on scroll) ---- */
  var headerOrderBtn = document.getElementById('header-order-btn');
  if (headerOrderBtn) {
    window.addEventListener('scroll', function() {
      headerOrderBtn.style.display = window.scrollY > 300 ? 'inline-flex' : 'none';
    });
  }

})();
